export default __webpack_public_path__ + "static/media/Sprite_Icon_Stat_02.391360c0.png";